import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bc5d0db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("搜索访问密钥")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("搜索密钥说明")
const _hoisted_13 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_14 = { class: "card-body table-responsive p-0" }
const _hoisted_15 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_16 = { ref: "tableTr" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "序号", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workYtoStatus" }, "状态", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "reporterCode" }, "上报人工号", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "reporterName" }, "上报人姓名", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "reporterMobile" }, "上报人手机", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "exceptionStartTime" }, "故障开始时间", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "taskId" }, "任务ID", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workOrderNo" }, "工单号", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "assetCode" }, "资产编码", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "deviceCode" }, "设备编码", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "belongOrgCode" }, "中心代码", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "belongOrgName" }, "中心名称", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "urgency" }, "紧急程度", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "deviceType" }, "设备类型", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "operatingArea" }, "操作区域", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "exceptionDesc",
  class: "normal-width text-left"
}, "异常描述", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createName" }, "创建姓名", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "创建时间", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "handlerCode" }, "处理人工号", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "handlerName" }, "处理人姓名", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "handlerMobile" }, "处理人手机", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "handleDesc" }, "处理详情", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "handleStatus" }, "推送状态", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "handleTime" }, "推送时间", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "handleMessage",
  class: "normal-width text-left"
}, "推送结果", -1))
const _hoisted_43 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40,
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["colspan"]
const _hoisted_46 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_47 = { class: "table-btn-group" }
const _hoisted_48 = { class: "btn-group" }
const _hoisted_49 = { class: "text-left" }
const _hoisted_50 = { class: "text-left" }
const _hoisted_51 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_52 = { class: "content-modal" }
const _hoisted_53 = { class: "row" }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_button_tooltip = _resolveComponent("app-button-tooltip")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_alert = _resolveComponent("app-alert")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_textarea = _resolveComponent("app-textarea")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/aftersale/ticket/works/yto/add'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "add" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/aftersale/ticket/works/yto/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/aftersale/ticket/works/yto/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_9
                      ]),
                      _hoisted_10,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchFunction('access_key')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_11
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('secret_remark')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_12
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[7] || (_cache[7] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.Auth('/aftersale/ticket/works/yto/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_16, _hoisted_43, 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_46
                          ], 8, _hoisted_45)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.secretId,
                        class: _normalizeClass({'text-red': parseInt(item.secretStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        _createElementVNode("td", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            (_ctx.Auth('/aftersale/ticket/works/yto/setProject'))
                              ? (_openBlock(), _createBlock(_component_app_button_tooltip, {
                                  key: 0,
                                  content: "匹配设备",
                                  onBtnClick: $event => (_ctx.setProject(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { name: "build-outline" })
                                  ]),
                                  _: 2
                                }, 1032, ["onBtnClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.Auth('/aftersale/ticket/works/yto/workSend'))
                              ? (_openBlock(), _createBlock(_component_app_button_tooltip, {
                                  key: 1,
                                  content: "发起工单",
                                  onBtnClick: $event => (_ctx.workSend(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { name: "navigate-circle-outline" })
                                  ]),
                                  _: 2
                                }, 1032, ["onBtnClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.Auth('/aftersale/ticket/works/yto/workOver'))
                              ? (_openBlock(), _createBlock(_component_app_button_tooltip, {
                                  key: 2,
                                  content: "反馈工单",
                                  onBtnClick: $event => (_ctx.workOver(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { name: "arrow-undo-circle-outline" })
                                  ]),
                                  _: 2
                                }, 1032, ["onBtnClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.workYtoStatus), 1),
                        _createElementVNode("td", null, _toDisplayString(item.reporterCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.reporterName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.reporterMobile), 1),
                        _createElementVNode("td", null, _toDisplayString(item.exceptionStartTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.taskId), 1),
                        _createElementVNode("td", null, _toDisplayString(item.workOrderNo), 1),
                        _createElementVNode("td", null, _toDisplayString(item.assetCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.deviceCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.belongOrgCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.belongOrgName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.urgency), 1),
                        _createElementVNode("td", null, _toDisplayString(item.deviceType), 1),
                        _createElementVNode("td", null, _toDisplayString(item.operatingArea), 1),
                        _createElementVNode("td", _hoisted_49, _toDisplayString(item.exceptionDesc), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.handlerCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.handlerName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.handlerMobile), 1),
                        _createElementVNode("td", null, _toDisplayString(item.handleDesc), 1),
                        _createElementVNode("td", null, _toDisplayString(item.handleStatus), 1),
                        _createElementVNode("td", null, _toDisplayString(item.handleTime), 1),
                        _createElementVNode("td", _hoisted_50, _toDisplayString(item.handleMessage), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_52, [
      _createVNode(_component_app_select_level, {
        ref: "userCodeLevel",
        levelType: "onLest",
        levelApi: _ctx.getUserApi,
        selectItem: _ctx.tableRequestItem.lockItem.userCode,
        maxParentId: _ctx.authUser.orgCode,
        selectFunction: _ctx.userCodeLevelFunction,
        searchFieldList: _ctx.userCodeLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_alert, { ref: "delModal" }, null, 512),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: _ctx.editModalTitle,
        submitButtonName: _ctx.editModalSubmitButtonName,
        size: "lg",
        submitFunction: _ctx.editModalSubmit,
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "*上报人工号",
              modelValue: _ctx.editModalItem.reporterCode,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.editModalItem.reporterCode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "*上报人姓名",
              modelValue: _ctx.editModalItem.reporterName,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.editModalItem.reporterName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "*上报人手机",
              modelValue: _ctx.editModalItem.reporterMobile,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.editModalItem.reporterMobile) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "*故障开始时间",
              modelValue: _ctx.editModalItem.exceptionStartTime,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.editModalItem.exceptionStartTime) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "*任务ID",
              modelValue: _ctx.editModalItem.taskId,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.editModalItem.taskId) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "*工单号",
              modelValue: _ctx.editModalItem.workOrderNo,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.editModalItem.workOrderNo) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "*资产编码",
              modelValue: _ctx.editModalItem.assetCode,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.editModalItem.assetCode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "*设备编码",
              modelValue: _ctx.editModalItem.deviceCode,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.editModalItem.deviceCode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "中心代码",
              modelValue: _ctx.editModalItem.belongOrgCode,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.editModalItem.belongOrgCode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "中心名称",
              modelValue: _ctx.editModalItem.belongOrgName,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.editModalItem.belongOrgName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "*紧急程度",
              modelValue: _ctx.editModalItem.urgency,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.editModalItem.urgency) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "*设备类型",
              modelValue: _ctx.editModalItem.deviceType,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.editModalItem.deviceType) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "*操作区域",
              modelValue: _ctx.editModalItem.operatingArea,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.editModalItem.operatingArea) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_textarea, {
              class: "col-lg-12",
              label: "*异常描述",
              modelValue: _ctx.editModalItem.exceptionDesc,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.editModalItem.exceptionDesc) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title", "submitButtonName", "submitFunction"])
    ])
  ]))
}